<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div class="login-signup alert-msg mb-2" style="width: 580px; margin-top: 123px; margin-bottom: 100px;">
          <div class="alert custom-alert" role="alert">
            <p>
              Welcome to TTN Fleet Solutions. Please confirm your email address by following the instructions in your
              email.
              <!-- <a (click)="showPinField()">Verify Mobile Number</a> -->
            </p>
          </div>
        </div>
        <div class="login-signup alert-msg pt-2 mt-1" *ngIf="booleanPinField">
          <div *ngIf="verifyEmail" class="alert custom-alert" role="alert">
            <p>The Verification code is sent to your mobile.Please verify!</p>
          </div>
          <div *ngIf="!verifyEmail" class="alert custom-alert-danger">
            <p>Please verify your email. <a (click)="showPinField()">Try again.</a></p>
          </div>
          <form *ngIf="verifyEmail" [formGroup]="pinDetail" class="pt-2" (ngSubmit)="submitPin()">
            <ul>
              <li>
                <input type="number" formControlName="mobilePin" placeholder="Verification Code">
                <div *ngIf="submitted && pinDetail.controls.mobilePin.errors" class="error">
                  <div *ngIf="pinDetail.controls.mobilePin.errors.required">
                    <div class="alert custom-alert-danger" role="alert">
                      <span class="sr-only">Error:</span>
                      Pin Number is required
                    </div>
                  </div>
                </div>
                <div *ngIf="invalidPin" class="error">
                  <div class="alert custom-alert-danger" role="alert">
                    <span class="sr-only">Error:</span>
                    Please enter valid pin number.
                  </div>
                </div>
              </li>
              <li>
              </li>
              <li>
                <input type="submit" name="submit" value="Submit">
              </li>
            </ul>
          </form>
        </div>
      </div>
    </section>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>
